import { updateObject } from "../../../../shared";
import {
  globalConstants,
  PAGINATION_DEFAULTS,
  performanceConstants,
  PERFORMANCE_METRIC_DEFAULTS,
} from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const {
  ALL_BRAND_RESPONSE_DATA,
  GET_INBOX_CONVERSATION_DATA,
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
  ALL_BRAND_CONVERSION_RESPONSE_DATA,
  GET_INBOX_CONVERSATION_SUMMARY_DATA,
  SURVEY_CONVERSION_RATE_KPI_SUMMARY_DATA,
  GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID,
  GET_ALL_BRANDS_CONVERSION_RESPONSES_FOR_EXPORT,
} = performanceConstants;

// Give each page and summary figure its own copy of the shared defaults.
const initialState = {
  allItemsForExport: [],
  brandResponsesData: [],
  allBrandResponsesData: [],
  brandResponseDataPagination: {
    ...PAGINATION_DEFAULTS,
  },
  surveyConversionRateKpiSummary: {
    totalSurveySentCount: { ...PERFORMANCE_METRIC_DEFAULTS },
    totalGoogleReviewCount: { ...PERFORMANCE_METRIC_DEFAULTS },
    totalSurveyOpenedCount: { ...PERFORMANCE_METRIC_DEFAULTS },
    totalSurveyStartedCount: { ...PERFORMANCE_METRIC_DEFAULTS },
    totalSurveyCompleteCount: { ...PERFORMANCE_METRIC_DEFAULTS },
    totalReceiveGoogleLinkCount: { ...PERFORMANCE_METRIC_DEFAULTS },
  },
  brandConversionData: [],
  brandConversionDataPagination: {
    ...PAGINATION_DEFAULTS,
  },
  inboxConversationSummary: {
    totalConversationCount: {
      ...PERFORMANCE_METRIC_DEFAULTS,
    },
    totalConversationNotStartedCount: {
      ...PERFORMANCE_METRIC_DEFAULTS,
    },
    totalConversationStartedCount: {
      ...PERFORMANCE_METRIC_DEFAULTS,
    },
    totalConsumerNotRespondedCount: {
      ...PERFORMANCE_METRIC_DEFAULTS,
    },
    totalConsumerRespondedCount: {
      ...PERFORMANCE_METRIC_DEFAULTS,
    },
  },
  inboxConversationData: [],
  inboxConversationDataPagination: {
    ...PAGINATION_DEFAULTS,
  },
  inboxConversationDataExport: [],
  inboxConversationDataByBrandId: [],
  allStoresCount: 0,
};

export const performanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_BRAND_RESPONSE_DATA + SUCCESS:
      return updateObject(state, {
        allBrandResponsesData: action.data.pageData,
        brandResponsesData: action.data.pageData.result,
        brandResponseDataPagination: action.data.page,
      });
    case ALL_BRAND_CONVERSION_RESPONSE_DATA + SUCCESS:
      return updateObject(state, {
        brandConversionData: action.data.data,
        brandConversionDataPagination: action.data.page,
      });
    case ALL_BRAND_CONVERSION_RESPONSE_DATA + FAILURE:
      return updateObject(state, {
        brandConversionData: initialState.brandConversionData,
        brandConversionDataPagination:
          initialState.brandConversionDataPagination,
      });
    case SURVEY_CONVERSION_RATE_KPI_SUMMARY_DATA + SUCCESS:
      return updateObject(state, {
        surveyConversionRateKpiSummary: action.data,
      });
    case SURVEY_CONVERSION_RATE_KPI_SUMMARY_DATA + FAILURE:
      return updateObject(state, {
        surveyConversionRateKpiSummary:
          initialState.surveyConversionRateKpiSummary,
      });
    case GET_ALL_BRANDS_CONVERSION_RESPONSES_FOR_EXPORT + SUCCESS:
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + SUCCESS:
      return updateObject(state, {
        allItemsForExport: action.data,
      });
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + FAILURE:
      return updateObject(state, { allItemsForExport: [] });
    case GET_INBOX_CONVERSATION_DATA + SUCCESS:
      return updateObject(state, {
        inboxConversationData: action.data.data,
        inboxConversationDataPagination: action.data.page,
      });
    case GET_INBOX_CONVERSATION_DATA + FAILURE:
      return updateObject(state, {
        inboxConversationData: initialState.inboxConversationData,
        inboxConversationDataPagination:
          initialState.inboxConversationDataPagination,
      });
    case GET_INBOX_CONVERSATION_SUMMARY_DATA + SUCCESS:
      return updateObject(state, {
        inboxConversationSummary: action.data,
      });
    case GET_INBOX_CONVERSATION_SUMMARY_DATA + FAILURE:
      return updateObject(state, {
        inboxConversationSummary: initialState.inboxConversationSummary,
      });
    case GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID + SUCCESS:
      const { data, count } = action.data;
      return updateObject(state, {
        inboxConversationDataByBrandId: [
          ...(state.inboxConversationDataByBrandId || []),
          ...(data || []),
        ],
        allStoresCount: count,
      });
    case GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID + FAILURE:
      return updateObject(state, {
        inboxConversationDataByBrandId:
          initialState.inboxConversationDataByBrandId,
        allStoresCount: initialState?.allStoresCount,
      });
    default:
      return state;
  }
};
